import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemsDelete: {},
  showDialog: false,
  isLoading: false,
};

//STORE SLICE
export const itemsDeleteSlice = createSlice({
  name: "itemsDeleteSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showDeleteItemsDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemsDelete: action.payload,
      };
    },
    closeDeleteItemsDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showDeleteItemsDialog,
  closeDeleteItemsDialog,
  showLoading,
  hideLoading
} = itemsDeleteSlice.actions;

export default itemsDeleteSlice.reducer;
